//only until bgt counters api is ready (wait for api refactor)
import entitysType from "../../enums/entitysType";
import Entity from "../models/Entity";

const bgtCountersConfig = {
    assessmentsToExamine: {
        id: "bgt-counter-open-tasks",
        name: "bgtOpenTasks",
        picture: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/prod/images/general/edit.png",
        getNumber: (response) => Number(response.assessmentsToExamine) || 0,
        tags: ["dashboard"],
    },
    unReadMessages: {
        id: "bgt-counter-new-messages",
        name: "bgtNewMessages",
        picture: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/prod/images/general/message.png",
        getNumber: (response) => Number(response.unReadMessages) || 0,
        tags: ["dashboard"],
    },
    studyGroups: {
        id: "bgt-counter-flexible-matriculations",
        name: "bgtFlexibleMatriculations",
        picture: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/prod/images/general/bgt.png",
        getNumber: (response) => {
            const studyGroups = response.studyGroups;
            if (!Array.isArray(studyGroups)) {
                return 0;
            }
            return studyGroups.reduce((sum, group) => sum + (Number(group?.count) || 0), 0);
        },
        tags: ["dashboard"],
    },
};

//only until bgt counters api is ready (wait for api refactor)
export const processBgtCounter = (response, endpoint, provider, metadata) => {
    const entitiesList = Object.keys(response)?.map(counter => {
        const currentCounter = bgtCountersConfig[counter];
        return new Entity({
            externalId: counter.id,
            id: counter.id,
            name: currentCounter.name,
            count: currentCounter.getNumber(response),
            picture: currentCounter.picture,
            tags: [...(endpoint?.tags || []), ...(currentCounter.tags || [])],
            type: entitysType.counter,
            ...counter,
        })
    });
    return { providerName: provider?.name, endpointKey: endpoint?.endpointKey, entitiesList }
}
